export const categories = [
  {
    id: "entertainment",
    name: "娱乐八卦",
    slug: "entertainment",
    description: "娱乐圈最新动态、明星绯闻、剧组内幕，第一手爆料尽在这里",
    icon: "ri-movie-line",
    articleCount: 128,
    color: "primary",
    image: "https://readdy.ai/api/search-image?query=Dramatic%20stage%20spotlight%20with%20red%20and%20gold%20lighting%20effects%2C%20theater%20curtains%2C%20celebrity%20atmosphere%2C%20dark%20elegant%20background%2C%20entertainment%20industry%20vibe%2C%20abstract%20artistic%20composition&width=600&height=400&seq=cat-ent-01&orientation=landscape",
  },
  {
    id: "influencer",
    name: "网红爆料",
    slug: "influencer",
    description: "头部网红翻车现场、人设崩塌、直播带货内幕，反差大瓜实时追踪",
    icon: "ri-live-line",
    articleCount: 96,
    color: "accent",
    image: "https://readdy.ai/api/search-image?query=Social%20media%20influencer%20studio%20setup%20with%20ring%20lights%20and%20cameras%2C%20dark%20moody%20atmosphere%2C%20neon%20accents%2C%20content%20creator%20aesthetic%2C%20professional%20photography%20with%20warm%20tones&width=600&height=400&seq=cat-inf-01&orientation=landscape",
  },
  {
    id: "social",
    name: "社会热点",
    slug: "social",
    description: "全网热议社会事件、民生话题、舆论焦点，吃瓜群众前排围观",
    icon: "ri-fire-line",
    articleCount: 156,
    color: "primary",
    image: "https://readdy.ai/api/search-image?query=Urban%20cityscape%20at%20night%20with%20crowd%20silhouettes%2C%20warm%20street%20lights%2C%20social%20gathering%20atmosphere%2C%20dramatic%20perspective%2C%20cinematic%20photography%20style%2C%20dark%20background%20with%20golden%20highlights&width=600&height=400&seq=cat-soc-01&orientation=landscape",
  },
  {
    id: "celebrity",
    name: "明星绯闻",
    slug: "celebrity",
    description: "顶流明星恋情曝光、婚变传闻、税务风波，深度扒皮不留死角",
    icon: "ri-star-line",
    articleCount: 84,
    color: "accent",
    image: "https://readdy.ai/api/search-image?query=Glamorous%20red%20carpet%20event%20atmosphere%2C%20spotlights%20and%20camera%20flashes%2C%20luxury%20elegant%20setting%2C%20dark%20background%20with%20warm%20golden%20light%2C%20celebrity%20event%20aesthetic%2C%20high%20fashion%20photography&width=600&height=400&seq=cat-cel-01&orientation=landscape",
  },
  {
    id: "industry",
    name: "圈内大瓜",
    slug: "industry",
    description: "娱乐圈行业秘闻、资本博弈、资源争夺战，知情人独家爆料",
    icon: "ri-briefcase-line",
    articleCount: 72,
    color: "secondary",
    image: "https://readdy.ai/api/search-image?query=Modern%20glass%20office%20building%20interior%20at%20night%2C%20dramatic%20lighting%2C%20city%20skyline%20reflection%2C%20corporate%20power%20atmosphere%2C%20dark%20elegant%20ambiance%2C%20professional%20architectural%20photography&width=600&height=400&seq=cat-ind-01&orientation=landscape",
  },
  {
    id: "contrast",
    name: "反差爆料",
    slug: "contrast",
    description: "人前光鲜人后塌房，人设与真实的强烈反差，揭露真相不留情面",
    icon: "ri-contrast-line",
    articleCount: 63,
    color: "primary",
    image: "https://readdy.ai/api/search-image?query=Split%20mirror%20reflection%20concept%2C%20half%20elegant%20half%20dark%20atmosphere%2C%20dramatic%20lighting%20contrast%2C%20theatrical%20mask%20symbolism%2C%20artistic%20photography%2C%20mysterious%20mood%20with%20warm%20and%20cool%20tones&width=600&height=400&seq=cat-con-01&orientation=landscape",
  },
];